import { ChangeEvent, FC, useEffect, useState } from 'react'
import { Badge, Button, Flex, Input, List } from 'antd'
import { useTranslation } from 'react-i18next'
import { CollapseIcon } from '../components'
import { carrierStore } from '../store/carrier'
import { RNCarriers, RNCarrierSelect, RNLogging } from '../helpers/routeNames'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Carrier } from '../helpers/types/carrier'
import { TickIcon } from '../components/icons/TickIcon'
import { utilityStore } from '../store/utils'
import { authStore } from '../store/auth'
import { notificationStore } from '../store/notification'

interface CarrierSelectProps {
	carrierId?: number
}

const CarrierSelect: FC<CarrierSelectProps> = ({ carrierId }) => {
	const { t } = useTranslation()
	const { carriers } = carrierStore()
	const { hash, search, pathname } = useLocation()
	const { logout } = authStore()
	const {
		sideBarShown,
		headerSwitchCarrierNotificationShown,
		setHeaderSwitchCarrierNotificationShown
	} = utilityStore()
	const { clearNotification } = notificationStore()

	const navigate = useNavigate()

	const [carrierSearch, setCarrierSearch] = useState<Carrier[]>([])
	const [searchCarrier, setSearchCarrier] = useState<string>('')
	const [selectedCarrier, setSelectedCarrier] = useState<Carrier>()

	useEffect(() => {
		setCarrierSearch(carriers)
	}, [carriers])

	useEffect(() => {
		if (!sideBarShown && search.includes('select'))
			setHeaderSwitchCarrierNotificationShown(false)
		else setHeaderSwitchCarrierNotificationShown(true)
		return () => setHeaderSwitchCarrierNotificationShown(true)
	}, [
		search,
		setHeaderSwitchCarrierNotificationShown,
		sideBarShown
	])

	const onSearch = (e: ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value.replace(/[^0-9]/g, '')

		setSearchCarrier(value)
		if (value === '') {
			setCarrierSearch(carriers)
			return
		}

		setCarrierSearch(
			carriers.filter((el) => {
				return el.name
					.toLowerCase()
					.includes(value.toLowerCase())
			})
		)
	}

	const logoutFc = () => {
		logout()
		clearNotification()
	}

	return (
		<Flex
			vertical
			gap={10}
			style={{
				height: `calc(100% - ${
					headerSwitchCarrierNotificationShown ? 36 : 0
				}px)`,
				position: 'relative'
			}}>
			<Flex
				vertical
				gap={16}
				style={{
					backgroundColor: 'var(--bg-color-zarafshon)'
				}}>
				{pathname !== RNCarrierSelect && (
					<Flex justify="space-between" align="center">
						<span
							style={{
								rotate: '270deg',
								transform:
									'scale(1.8) translateY(-3px)',
								width: 33,
								height: 33,
								cursor: 'pointer'
							}}
							onClick={() => navigate(hash)}>
							<CollapseIcon
								collapsed
								collapsedColor="#3894eb"
							/>
						</span>
						<Button onClick={logoutFc} type="primary">
							{t('Logout')}
						</Button>
					</Flex>
				)}
				<h2 style={{ margin: 0 }}>{t('SelectCarrier')}</h2>
				<div>
					<Input.Search
						type="search"
						placeholder={t('Search') as string}
						value={searchCarrier}
						onChange={onSearch}
						title="123123"
						size="large"
					/>
				</div>
			</Flex>
			<List
				style={{
					background: '#fff',
					margin: '0 -20px -16px',
					// overflowY: 'auto',
					paddingBottom: 80
				}}>
				{carrierSearch.length ? (
					carrierSearch.map((carrier) => (
						<List.Item
							key={carrier.id}
							style={{
								backgroundColor:
									carrierId === carrier?.id
										? '#cacaca'
										: '#fff',
								// color: '#142d49',

								fontSize: 17,
								padding: '16px 20px',
								cursor:
									carrierId !== carrier?.id
										? 'pointer'
										: 'not-allowed',
								borderBottom: '1px solid #EAECF3',
								display:
									selectedCarrier?.id === carrier.id
										? 'flex'
										: 'block',
								justifyContent: 'space-between',
								color:
									selectedCarrier?.id === carrier.id
										? '#3894eb'
										: '#142D49'
							}}
							onClick={() => {
								if (carrierId === carrier?.id) return
								setSelectedCarrier(carrier)
							}}>
							{carrier.name}
							{
								// TEMP DEV CHECK: show activeProblemsCount in CarrierSelect list
								// Comment out this block before deploying to production.
								carrier.activeProblemsCount > 0 ? (
									<Link
										to={`${RNLogging}/${carrier.id}?onlyErrors=true`}
										onClick={(event) => event.stopPropagation()}
										aria-label={`${carrier.name} errors`}
									>
										<Badge
											count={carrier.activeProblemsCount}
											style={{
												backgroundColor: '#ff4d4f',
												marginLeft: 10
											}}
										/>
									</Link>
								) : null
							}
							{selectedCarrier?.id === carrier.id && (
								<TickIcon />
							)}
						</List.Item>
					))
				) : (
					<List.Item
						style={{
							fontSize: 17,
							padding: '16px 36px'
						}}>
						{t('NoData')} 🙈🙈🙈
					</List.Item>
				)}
			</List>
			<Button
				size="large"
				type="primary"
				disabled={!selectedCarrier}
				style={{
					position: 'fixed',
					bottom: 20,
					right: 20,
					left: 20
				}}
				onClick={() =>
					navigate(RNCarriers + '/' + selectedCarrier!.id)
				}>
				{t('Continue')}
			</Button>
		</Flex>
	)
}

export default CarrierSelect
